<div class="ion-padding">
  <ion-header class="ion-text-center">Number of days to show:</ion-header>
  <div class="setting-option-container">
    <div tappable [ngClass]="{
          'setting-item': true,
          'setting-item-selected': day == daysToDisplay
        }" *ngFor="let day of dayNumbers" (click)="onSetDaysToDisplay(day)">
      <div class="setting-day-number">{{ day }}</div>
    </div>
  </div>
</div>